export const defaultState = {
    order: 'desc',
    orderBy: 'appointmentDate',
    selected: [],
    page: 0,
    rowsPerPage: 25,
    selectedOperator: -1,
    searchNeedle: '',
    pendingList: [],
    next: {},
    lastQueryType: 1,
    lasNoOfRows: -1,
    totalRows: 0,
    openChat: false,
    selectedRequest: null,
    reset: false,
    status: 'all',
    selectedRow: null,
    selectedDate: {
        date: null,
        value: null,
        date2: null,
        value2: null
    },
    selectedToDate: {
        date: null,
        value: null,
        date2: null,
        value2: null
    },
    dateFilterFor: {
        basic: 'appointmentDate',
        advanced: ''
    },
    requestStatus: 'all',
    advancedOptions: false,
    selectedSponsor: -1,
    searchRequestId: '',
};

export default function user(state = defaultState, action) {
    switch (action.type) {
        case 'PO_SET_ORDER':
            return Object.assign({}, state, { order: action.payload });
        case 'PO_SET_ORDER_BY':
            return Object.assign({}, state, { orderBy: action.payload });
        case 'PO_SET_SELECTED_FOR_CLAIM':
            return Object.assign({}, state, { selected: action.payload });
        case 'PO_SET_CURRENT_PAGE':
            return Object.assign({}, state, { page: action.payload });
        case 'PO_SET_ROWS_PER_PAGE':
            return Object.assign({}, state, { rowsPerPage: action.payload });
        case 'PO_SET_SELECTED_OPERATOR':
            return Object.assign({}, state, { selectedOperator: action.payload });
        case 'PO_SET_SEARCH_NEEDLE':
            return Object.assign({}, state, { searchNeedle: action.payload });
        case 'PO_SET_PENDING_DATA':
            return {
                ...state,
                pendingList: action.payload.pendingList,
                next: {
                    ...state.next,
                    [state.page + 1]: action.payload.next
                },
                lastQueryType: action.payload.lastQueryType,
                lastNoOfRows: action.payload.lastNoOfRows,
                totalRows: action.payload.totalRows
            };
        case 'PO_SET_PENDING_LIST':
            return Object.assign({}, state, { pendingList: action.payload });
        case 'PO_SET_NEXT':
            return Object.assign({}, state, { next: action.payload });
        case 'PO_SET_LAST_QUERY_TYPE':
            return Object.assign({}, state, { lastQueryType: action.payload });
        case 'PO_SET_LAST_NO_OF_ROWS':
            return Object.assign({}, state, { lastNoOfRows: action.payload });
        case 'PO_SET_TOTAL_NO_ROWS':
            return Object.assign({}, state, { totalRows: action.payload });
        case 'PO_SET_OPEN_CHAT':
            return Object.assign({}, state, { openChat: action.payload });
        case 'PO_SET_SELECTED_REQUEST':
            return Object.assign({}, state, { selectedRequest: action.payload });
        case 'PO_SET_RESET_FILTERS':
            return defaultState;
        case 'PO_SET_ONBOARDING_STATUS':
            return Object.assign({}, state, { status: action.payload });
        case 'PO_SET_SELECTED_ROW':
            return Object.assign({}, state, { selectedRow: action.payload });
        case 'PO_SET_SELECTED_DATE_FROM':
            return Object.assign({}, state, { selectedDate: action.payload });
        case 'PO_SET_SELECTED_DATE_TO':
            return Object.assign({}, state, { selectedToDate: action.payload });
        case 'PO_SET_DATE_FILTER_FOR':
            return Object.assign({}, state, { dateFilterFor: action.payload });
        case 'PO_SET_REQUEST_STATUS':
            return Object.assign({}, state, { requestStatus: action.payload });
        case 'PO_SET_ADVANCED_OPTIONS':
            return Object.assign({}, state, { advancedOptions: action.payload });
        case 'PO_SET_SELECTED_SPONSOR':
            return Object.assign({}, state, { selectedSponsor: action.payload });
        case 'PO_SET_SEARCH_REQUEST_ID':
            return Object.assign({}, state, { searchRequestId: action.payload });
        default:
            return state;
    }
}
